package com.example.mystybag.sharedmodels.base

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmField

@Serializable
open class BaseResponseModel(
    @JvmField
    var command             : Int       = 0,
    @JvmField
    var apiEndPoint         : String    = "",
    @JvmField
    @SerialName("status_message")
    var statusMessage       : String    = "",
    @JvmField
    @SerialName("status_details")
    var statusDetails       : String    = "",
    @JvmField
    var status              : Int       = 0,
    @JvmField
    var api                 : String    = ""
)